import React from 'react';

import useAuthFlow from 'state/auth/hooks/use-auth-flow';
import { t } from 'state/intl/translations';

import { GetStartedText } from './sign-up-headline.styled';

interface ISignUpHeadlineTextProps {
  rewardsLink: React.ReactNode;
}

const SignUpHeadlineText: React.FC<ISignUpHeadlineTextProps> = ({ rewardsLink }) => {
  const { showOtpForm } = useAuthFlow();

  let signUpLabel;
  if (showOtpForm) {
    signUpLabel = t('otpFormHeadline');
  } else {
    signUpLabel = t('signUpOrSignIn');
  }

  return (
    <GetStartedText accessibilityLevel={2} accessibilityRole="header" testID="sign-up-label">
      {signUpLabel}
    </GetStartedText>
  );
};

export default SignUpHeadlineText;
